/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiBillingInvoicesGet } from '../fn/billing/api-billing-invoices-get';
import { ApiBillingInvoicesGet$Params } from '../fn/billing/api-billing-invoices-get';
import { apiBillingInvoicesLagoInvoiceIdPaymentUrlPost } from '../fn/billing/api-billing-invoices-lago-invoice-id-payment-url-post';
import { ApiBillingInvoicesLagoInvoiceIdPaymentUrlPost$Params } from '../fn/billing/api-billing-invoices-lago-invoice-id-payment-url-post';
import { apiBillingInvoicesPendingGet } from '../fn/billing/api-billing-invoices-pending-get';
import { ApiBillingInvoicesPendingGet$Params } from '../fn/billing/api-billing-invoices-pending-get';
import { apiBillingPaymentMethodStatusGet } from '../fn/billing/api-billing-payment-method-status-get';
import { ApiBillingPaymentMethodStatusGet$Params } from '../fn/billing/api-billing-payment-method-status-get';
import { apiBillingPlansCodeGet } from '../fn/billing/api-billing-plans-code-get';
import { ApiBillingPlansCodeGet$Params } from '../fn/billing/api-billing-plans-code-get';
import { apiBillingPlansGet } from '../fn/billing/api-billing-plans-get';
import { ApiBillingPlansGet$Params } from '../fn/billing/api-billing-plans-get';
import { apiBillingPortalUrlGet } from '../fn/billing/api-billing-portal-url-get';
import { ApiBillingPortalUrlGet$Params } from '../fn/billing/api-billing-portal-url-get';
import { apiBillingSubscriptionCancelPost } from '../fn/billing/api-billing-subscription-cancel-post';
import { ApiBillingSubscriptionCancelPost$Params } from '../fn/billing/api-billing-subscription-cancel-post';
import { apiBillingSubscriptionChangePost } from '../fn/billing/api-billing-subscription-change-post';
import { ApiBillingSubscriptionChangePost$Params } from '../fn/billing/api-billing-subscription-change-post';
import { apiBillingSubscriptionGet } from '../fn/billing/api-billing-subscription-get';
import { ApiBillingSubscriptionGet$Params } from '../fn/billing/api-billing-subscription-get';
import { CreateOrUpdateSubscriptionResult } from '../models/create-or-update-subscription-result';
import { GenerateInvoicePaymentUrlResult } from '../models/generate-invoice-payment-url-result';
import { GetCurrentSubscriptionResult } from '../models/get-current-subscription-result';
import { GetCustomerPortalUrlResult } from '../models/get-customer-portal-url-result';
import { GetInvoicesResult } from '../models/get-invoices-result';
import { GetPaymentMethodStatusResult } from '../models/get-payment-method-status-result';
import { GetPlansResult } from '../models/get-plans-result';
import { PlanDto } from '../models/plan-dto';


/**
 * Plans, subscriptions and invoices
 */
@Injectable({ providedIn: 'root' })
export class BillingService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiBillingPlansGet()` */
  static readonly ApiBillingPlansGetPath = '/api/Billing/plans';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingPlansGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingPlansGet$Response(params?: ApiBillingPlansGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlansResult>> {
    const obs = apiBillingPlansGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingPlansGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingPlansGet(params?: ApiBillingPlansGet$Params, context?: HttpContext): Observable<GetPlansResult> {
    const resp = this.apiBillingPlansGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetPlansResult>): GetPlansResult => r.body)
    );
  }

  /** Path part for operation `apiBillingPlansCodeGet()` */
  static readonly ApiBillingPlansCodeGetPath = '/api/Billing/plans/{code}';

  /**
   * Public (no-auth) lookup of a single plan by code — used by landing/
   * pricing pages before the user has logged in. Returns 404 if missing.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingPlansCodeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingPlansCodeGet$Response(params: ApiBillingPlansCodeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
    const obs = apiBillingPlansCodeGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Public (no-auth) lookup of a single plan by code — used by landing/
   * pricing pages before the user has logged in. Returns 404 if missing.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingPlansCodeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingPlansCodeGet(params: ApiBillingPlansCodeGet$Params, context?: HttpContext): Observable<PlanDto> {
    const resp = this.apiBillingPlansCodeGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlanDto>): PlanDto => r.body)
    );
  }

  /** Path part for operation `apiBillingSubscriptionGet()` */
  static readonly ApiBillingSubscriptionGetPath = '/api/Billing/subscription';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingSubscriptionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingSubscriptionGet$Response(params?: ApiBillingSubscriptionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCurrentSubscriptionResult>> {
    const obs = apiBillingSubscriptionGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingSubscriptionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingSubscriptionGet(params?: ApiBillingSubscriptionGet$Params, context?: HttpContext): Observable<GetCurrentSubscriptionResult> {
    const resp = this.apiBillingSubscriptionGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetCurrentSubscriptionResult>): GetCurrentSubscriptionResult => r.body)
    );
  }

  /** Path part for operation `apiBillingSubscriptionChangePost()` */
  static readonly ApiBillingSubscriptionChangePostPath = '/api/Billing/subscription/change';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingSubscriptionChangePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBillingSubscriptionChangePost$Response(params?: ApiBillingSubscriptionChangePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrUpdateSubscriptionResult>> {
    const obs = apiBillingSubscriptionChangePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingSubscriptionChangePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBillingSubscriptionChangePost(params?: ApiBillingSubscriptionChangePost$Params, context?: HttpContext): Observable<CreateOrUpdateSubscriptionResult> {
    const resp = this.apiBillingSubscriptionChangePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateOrUpdateSubscriptionResult>): CreateOrUpdateSubscriptionResult => r.body)
    );
  }

  /** Path part for operation `apiBillingSubscriptionCancelPost()` */
  static readonly ApiBillingSubscriptionCancelPostPath = '/api/Billing/subscription/cancel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingSubscriptionCancelPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingSubscriptionCancelPost$Response(params?: ApiBillingSubscriptionCancelPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrUpdateSubscriptionResult>> {
    const obs = apiBillingSubscriptionCancelPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingSubscriptionCancelPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingSubscriptionCancelPost(params?: ApiBillingSubscriptionCancelPost$Params, context?: HttpContext): Observable<CreateOrUpdateSubscriptionResult> {
    const resp = this.apiBillingSubscriptionCancelPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateOrUpdateSubscriptionResult>): CreateOrUpdateSubscriptionResult => r.body)
    );
  }

  /** Path part for operation `apiBillingPaymentMethodStatusGet()` */
  static readonly ApiBillingPaymentMethodStatusGetPath = '/api/Billing/payment-method/status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingPaymentMethodStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingPaymentMethodStatusGet$Response(params?: ApiBillingPaymentMethodStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPaymentMethodStatusResult>> {
    const obs = apiBillingPaymentMethodStatusGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingPaymentMethodStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingPaymentMethodStatusGet(params?: ApiBillingPaymentMethodStatusGet$Params, context?: HttpContext): Observable<GetPaymentMethodStatusResult> {
    const resp = this.apiBillingPaymentMethodStatusGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetPaymentMethodStatusResult>): GetPaymentMethodStatusResult => r.body)
    );
  }

  /** Path part for operation `apiBillingPortalUrlGet()` */
  static readonly ApiBillingPortalUrlGetPath = '/api/Billing/portal-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingPortalUrlGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingPortalUrlGet$Response(params?: ApiBillingPortalUrlGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCustomerPortalUrlResult>> {
    const obs = apiBillingPortalUrlGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingPortalUrlGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingPortalUrlGet(params?: ApiBillingPortalUrlGet$Params, context?: HttpContext): Observable<GetCustomerPortalUrlResult> {
    const resp = this.apiBillingPortalUrlGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetCustomerPortalUrlResult>): GetCustomerPortalUrlResult => r.body)
    );
  }

  /** Path part for operation `apiBillingInvoicesGet()` */
  static readonly ApiBillingInvoicesGetPath = '/api/Billing/invoices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingInvoicesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingInvoicesGet$Response(params?: ApiBillingInvoicesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInvoicesResult>> {
    const obs = apiBillingInvoicesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingInvoicesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingInvoicesGet(params?: ApiBillingInvoicesGet$Params, context?: HttpContext): Observable<GetInvoicesResult> {
    const resp = this.apiBillingInvoicesGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetInvoicesResult>): GetInvoicesResult => r.body)
    );
  }

  /** Path part for operation `apiBillingInvoicesPendingGet()` */
  static readonly ApiBillingInvoicesPendingGetPath = '/api/Billing/invoices/pending';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingInvoicesPendingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingInvoicesPendingGet$Response(params?: ApiBillingInvoicesPendingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInvoicesResult>> {
    const obs = apiBillingInvoicesPendingGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingInvoicesPendingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingInvoicesPendingGet(params?: ApiBillingInvoicesPendingGet$Params, context?: HttpContext): Observable<GetInvoicesResult> {
    const resp = this.apiBillingInvoicesPendingGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetInvoicesResult>): GetInvoicesResult => r.body)
    );
  }

  /** Path part for operation `apiBillingInvoicesLagoInvoiceIdPaymentUrlPost()` */
  static readonly ApiBillingInvoicesLagoInvoiceIdPaymentUrlPostPath = '/api/Billing/invoices/{lagoInvoiceId}/payment-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBillingInvoicesLagoInvoiceIdPaymentUrlPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingInvoicesLagoInvoiceIdPaymentUrlPost$Response(params: ApiBillingInvoicesLagoInvoiceIdPaymentUrlPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GenerateInvoicePaymentUrlResult>> {
    const obs = apiBillingInvoicesLagoInvoiceIdPaymentUrlPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiBillingInvoicesLagoInvoiceIdPaymentUrlPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBillingInvoicesLagoInvoiceIdPaymentUrlPost(params: ApiBillingInvoicesLagoInvoiceIdPaymentUrlPost$Params, context?: HttpContext): Observable<GenerateInvoicePaymentUrlResult> {
    const resp = this.apiBillingInvoicesLagoInvoiceIdPaymentUrlPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GenerateInvoicePaymentUrlResult>): GenerateInvoicePaymentUrlResult => r.body)
    );
  }

}
